import * as React from "react";
import { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import pageIds from "pageIds";
import { CommonLibraryBuiltInRepositoryOverview, CommonLibraryBuiltInRepositoryTopics } from "../../CommonComponents/CommonLibraryBuiltInRepositoryViews";

export const LibraryBuiltInRepositoryPackageVersionsRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.library.builtInRepository.versions,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonLibraryBuiltInRepositoryOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonLibraryBuiltInRepositoryTopics />;
    }
};
